/* @jsx h */
import { defineComponent, h } from "vue";

const shimmer = (classes: string) => (
  <div class={["skeleton-shimmer rounded", classes]} />
);

const benefit = () => (
  <div class="flex items-start gap-3">
    <div class="size-10 shrink-0 rounded-xl skeleton-shimmer" />
    <div class="min-w-0 flex-1 pt-0.5">
      {shimmer("h-4 w-28")}
      {shimmer("mt-2 h-3 w-full max-w-52")}
    </div>
  </div>
);

/** Loading state shaped like the welcome card a signed-out visitor will see. */
export const SignedOutSkeleton = defineComponent({
  name: "CollectedSignedOutSkeleton",
  setup() {
    return () => (
      <div
        class="mx-auto flex w-full flex-col p-2"
        aria-busy="true"
        aria-live="polite"
      >
        <div class="overflow-hidden rounded-3xl border border-base-300 bg-base-100 shadow-sm">
          <div class="relative overflow-hidden bg-gradient-to-b from-primary/10 via-base-100 to-base-100 px-6 pb-8 pt-10 text-center sm:px-10 sm:pt-12">
            <div class="relative mx-auto mb-6 h-32 sm:h-40" aria-hidden="true">
              <div class="absolute inset-x-0 top-0 mx-auto aspect-[8/5] w-40 translate-y-3 -rotate-12 rounded-2xl skeleton-shimmer opacity-45 shadow-lg" />
              <div class="absolute inset-x-0 top-0 mx-auto aspect-[8/5] w-40 translate-y-1 rotate-12 rounded-2xl skeleton-shimmer opacity-70 shadow-lg" />
              <div class="absolute inset-x-0 top-0 mx-auto aspect-[8/5] w-40 -translate-y-1 rounded-2xl skeleton-shimmer shadow-lg" />
            </div>

            <div class="flex flex-col items-center">
              {shimmer("h-7 w-36 rounded-full")}
              {shimmer("mt-4 h-8 w-full max-w-sm")}
              {shimmer("mt-3 h-4 w-full max-w-xs")}
            </div>
          </div>

          <div class="space-y-5 px-6 pb-6 sm:px-10 sm:pb-8">
            <div class="grid gap-4 sm:grid-cols-2">
              {benefit()}
              {benefit()}
              {benefit()}
            </div>
          </div>
        </div>

        <div class="mt-5 px-2 sm:px-0">
          {shimmer("h-12 w-full rounded-2xl")}
          {shimmer("mx-auto mt-3 h-3 w-48")}
        </div>
      </div>
    );
  },
});
